var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetinAltta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Metin-Altta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-774.000000, -2495.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(774.000000, 2495.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6923077,22 L12.6923077,23.6923077 L0,23.6923077 L0,22 L12.6923077,22 Z M22,19.4615385 L22,21.1538462 L0,21.1538462 L0,19.4615385 L22,19.4615385 Z M21,0 C21.5522847,-1.01453063e-16 22,0.44771525 22,1 L22,15.9230769 C22,16.4753617 21.5522847,16.9230769 21,16.9230769 L1,16.9230769 C0.44771525,16.9230769 6.76353751e-17,16.4753617 0,15.9230769 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L21,0 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetinAltta);
export default __webpack_public_path__ + "static/media/Metin-Altta.79b7066e9e8d85093dcb8d7655541ddc.svg";
export { ForwardRef as ReactComponent };